module.exports = __webpack_public_path__ + "img/banner.d2fdcf46.jpg";